import React, {useState} from "react";
import ThemeData from "../../../Interfaces/ThemeData";
import Loader from "../../Common/Loader";
import * as Sentry from "@sentry/react";

interface ThemesListItemProps {
    data: ThemeData,
    index: number,
    onClickAction: (data: ThemeData) => void
    onSelectThemeAction: (data: ThemeData) => void,
    onImageLoaded: (data: ThemeData) => void
}

const ThemesListItem: React.FC<ThemesListItemProps> = ({
                                                           data,
                                                           index,
                                                           onClickAction,
                                                           onSelectThemeAction,
                                                           onImageLoaded
                                                       }) => {
    const [isThumbImageLoaded, setIsThumbImageLoaded] = useState(false);

    return (
        <div
            className={`theme-item ${data.isActive ? 'active' : ''}`}
            key={'theme-list-item-component-' + data.themeId}
        >
            <div>
                <div className={`image-container ${isThumbImageLoaded ? 'loaded' : ''}`}
                     onClick={() => {
                         onClickAction(data)
                     }}>
                    <img
                        key={'theme-list-item-component-image-' + data.themeId}
                        src={data.thumbnailUrl}
                        alt={data.title}
                        className={'img-fluid'}
                        onLoad={() => {
                            setIsThumbImageLoaded(true);
                            // onImageLoaded(data);
                        }}
                        onError={(e) => {
                            let src = (e.target as HTMLImageElement).src;
                            let url = new URL(src);
                            if (!url.searchParams.has('i') || (url.searchParams.has('i') && parseInt(url.searchParams.get('i') ?? '') < 15)) {
                                url.searchParams.set('r', (new Date()).getTime().toString());
                                url.searchParams.set('i', url.searchParams.has('i') ? (parseInt(url.searchParams.get('i') ?? '') + 1).toString() : '1');
                                setTimeout(() => {
                                    (e.target as HTMLImageElement).src = url.toString();
                                }, 1000);
                            } else {
                                Sentry.captureException(
                                    new Error('Failed to load theme thumbnail.'),
                                    {
                                        extra: {src: (e.target as HTMLImageElement).src}
                                    }
                                );
                            }
                        }}
                    />
                    <Loader showTransparentImage={true}
                            isPositionAbsolute={false}
                            isLoaded={isThumbImageLoaded}
                            onLoad={onImageLoaded}/>
                </div>
                <div className={'activeOverlay'}>
                    <div>
                        <span className={'fa fa-circle-check'}></span>
                    </div>
                    <div className={'text'}>Выбранная тема</div>
                </div>
                <span className="index">{index + 1}</span>
            </div>
        </div>
    );
}

export default ThemesListItem;